var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "report-area" }, [
    _c("h1", { staticClass: "h1" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("report.header")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "desc" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("report.header_desc")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "desc" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("report.payouts")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "desc hint" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("report.desc_hint1")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "desc hint" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("report.desc_hint2")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "h4" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("report.submit_header")) + ":\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-area" }, [
      _c("div", { staticClass: "input-area w-50" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("report.title")) + ":\n      "),
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "text",
            сlass: "input",
            placeholder: _vm.$t("report.title_plc"),
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-area w-50" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("\n        " + _vm._s(_vm.$t("report.email")) + ":\n      "),
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "text",
            сlass: "input",
            placeholder: _vm.$t("report.email_plc"),
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-area" },
        [
          _c("label", { staticClass: "label" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("report.level")) + ":\n      "),
          ]),
          _vm._v(" "),
          _c("Select", {
            attrs: { options: _vm.levels },
            model: {
              value: _vm.form.level,
              callback: function ($$v) {
                _vm.$set(_vm.form, "level", $$v)
              },
              expression: "form.level",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-area" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("report.description")) + ":\n      "
          ),
        ]),
        _vm._v(" "),
        _c("textarea", {
          attrs: {
            rows: "6",
            сlass: "input textarea",
            placeholder: _vm.$t("report.description_plc"),
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons-area" }, [
        _c(
          "button",
          {
            class: { "btn cyan": true, disabled: _vm.loading },
            attrs: { type: "button" },
            on: { click: _vm.submitReport },
          },
          [
            !_vm.loading
              ? _c("span", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("report.submit")) +
                      "\n        "
                  ),
                ])
              : _c("span", [_c("Loading")], 1),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }